export const UNDERWRITING_STATUS_CONFIG = {
  eligible: {
    label: 'Likely Eligible',
    classes: {
      bgColor: 'bg-green-600/5',
      textColor: 'text-green-800',
      borderColor: 'border-green-600/20',
      hoverBgColor: 'hover:bg-green-600/10',
    },
  },
  unsure: {
    label: 'Review Needed',
    classes: {
      bgColor: 'bg-yellow-600/5',
      textColor: 'text-yellow-800',
      borderColor: 'border-yellow-600/20',
      hoverBgColor: 'hover:bg-yellow-600/10',
    },
  },
  ineligible: {
    label: 'Likely Ineligible',
    classes: {
      bgColor: 'bg-destructive/5',
      textColor: 'text-destructive',
      borderColor: 'border-destructive/10',
      hoverBgColor: 'hover:bg-destructive/10',
    },
  },
} as const;

export const UNDERWRITING_STATUS_FILTERS = Object.entries(UNDERWRITING_STATUS_CONFIG).map(
  ([value, config]) => ({
    value,
    label: config.label,
    classes: config.classes,
  }),
);

export const PROMPT_TYPE_TO_CARRIER_MAP: Record<string, string> = {
  'underwriting-cs-guidance': 'CareScout',
  'underwriting-nw-guidance': 'Nationwide',
  'underwriting-oa-guidance': 'OneAmerica',
  'underwriting-securian-guidance': 'Securian',
  'underwriting-lincoln-guidance': 'Lincoln Financial',
};
